module.exports = __webpack_public_path__ + "cc33d1d2d44fea202e8054763c4578b2.pdf";